window.initApp = function () {
    return {
        isMobileSidebarOpen: false,
        isProfileDropdownShowing: false,
        showCopied: false,
        toggleSideBar() {
            this.isMobileSidebarOpen = !this.isMobileSidebarOpen
        },
        toggleProfileDropDown() {
            this.isProfileDropdownShowing = !this.isProfileDropdownShowing
        },
        copyValue(ref) {
            let aux = document.createElement("input");
            aux.setAttribute("value", this.$refs[ref].innerHTML);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            this.showCopied = true
            setTimeout(() => {
                this.showCopied = false
            }, 2000);
        },
        toBrowserDate(date) {
            return window.moment.tz(window.moment.unix(date), window.moment.tz.guess()).format('ddd DD/MM/YY HH:mm')
        }
    }
}

window.initializeFlash = function () {
    return {
        hideMessage(key) {
            if (this.$refs[key]) {
                this.$refs[key].remove()
            }
        }
    }
}
